import angular from 'angular';
import uiRouter from 'angular-ui-router';
import contactComponent from './contact.component';
import ContactSearch from './contactSearch/contactSearch';
import ContactEdit from './contactEdit/contactEdit';
import ContactList from './contactList/contactList';
import ContactView from './contactView/contactView';
import ContactService from './contact.service';

let contactModule = angular.module('contact', [
  uiRouter,
  ContactEdit,
  ContactList,
  ContactSearch,
  ContactView
])

.component('contact', contactComponent)

.service('contactService', ContactService)

.name;

export default contactModule;



// WEBPACK FOOTER //
// ./client/app/components/contact/contact.js